import React, { useCallback, useState } from 'react'
import Dialog from '@/components/ui/Dialog'
import classNames from 'classnames'

const LightboxImage = (props) => {
    const { children, src, className, component = null, onClick, ...rest } = props
    const [isZoomDialogOpen, setZoomDialogOpen] = useState(false)

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setZoomDialogOpen(true)
        onClick?.()
    }

    let Component = component ? (props)=> component(props) : ({children, ...props})=> <img {...props}/>

    const renderChildren = useCallback(() => {
        return <Component
            className={classNames(className, 'cursor-pointer')}
            onClick={handleClick}
            {...props}>{children}</Component>

    }, [children, Component])

    return <>
        {renderChildren()}
        <Dialog
            className={'p-0'}
            contentClassName={'p-0'}
            isOpen={isZoomDialogOpen}
            onClose={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setZoomDialogOpen(false)
            }}
            onRequestClose={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setZoomDialogOpen(false)
            }}
        >
            <img src={src} className={'w-full'} />
        </Dialog>
    </>
}

export default React.memo(LightboxImage)
